import { theme } from '../../constants/defaults';

window.stockistSearchCompleted = () => {
  // Called as soon as a search has completed and the result <ul> has been updated
  const results = document.querySelectorAll('.stockist-result-addr-country');
  results.forEach((result) => {
    const countryName = result.innerText;
    let countryTranslation = countryName;

    switch (countryName) {
      case 'Belgium':
        countryTranslation = theme.strings.storelocator.belgium;
        break;
      case 'France':
        countryTranslation = theme.strings.storelocator.france;
        break;
      case 'Netherlands':
        countryTranslation = theme.strings.storelocator.netherlands;
        break;
      case 'Germany':
        countryTranslation = theme.strings.storelocator.germany;
        break;
      case 'Luxembourg':
        countryTranslation = theme.strings.storelocator.luxembourg;
        break;
      default:
        break;
    }

    result.innerText = countryTranslation;
  });
};
